// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6bd3e6f9","453":"18e1a2b4"}[chunkId] + ".chunk.js";
};